import React from 'react'

function Search() {
  return (
    <div className="loading-message hero">
      <div className="hero-body">
        <div className="container">
          <h1>Search ArtMatch</h1>
          <p>Coming soon – search for your dream ArtMatch!</p>
        </div>
      </div>
    </div>
  )
}

export default Search